import React from 'react';

export interface IconBaseProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
  color?: string;
  className?: string;
  viewBox?: string;
}

const IconBase: React.FC<IconBaseProps & {children: React.ReactNode}> = ({
  size = 24,
  color = 'currentColor',
  className = '',
  viewBox = '0 0 24 24',
  children,
  ...props
}) => {
  const iconSize = typeof size === 'number' ? size : parseInt(size as string, 10) || 24;
  return (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox={viewBox}
      fill={color}
      className={className}
      {...props}
    >
      {children}
    </svg>
  );
};

export default IconBase;
